import api from './client';

export const getJobPackages    = (projectId) => projectId
  ? api.get('/job-packages', { params: { project: projectId } })
  : api.get('/job-packages');
export const getUnreadCount    = () => api.get('/job-packages/unread-count');
export const createJobPackage  = (data) => api.post('/job-packages', data);
export const updateJobPackage  = (id, data) => api.put(`/job-packages/${id}`, data);
export const deleteJobPackage  = (id) => api.delete(`/job-packages/${id}`);
export const markJobPkgRead    = (id) => api.post(`/job-packages/${id}/read`);
export const patchJobPkgStatus = (id, status) => api.patch(`/job-packages/${id}/status`, { status });
